import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol, ContainerEdit } from '../componentes_generales/componentes_formulario/contenedores';
import InputSearch from '../componentes_generales/componentes_formulario/inputs/inputsearch';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';
import { formatearNumeroDecimal, desformatearNumeroDecimal } from '../../funciones_globales/format';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import global_axios  from '../../funciones_globales/interaccionapi';
import { cargarCatalogos } from '../../funciones_globales/catalogos';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import '../componentes_generales/componentes_formulario/contenedores/flexbox.css'
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { formatearNumeroEntero, completar_String } from '../../funciones_globales/format';
import { validarPermisoAcceso } from '../../funciones_globales/utils';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';

class FormCaja08 extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            //GLOBAL
            permiso: null,
            operacion: 'G',

            tipo_opt: [],
            tipo_sel: 'COB',
            tipoins_sel: 'COB', //INSERT PARA EL TIPO DE PRESUPUESTO
            //Texto
            periodo: '',
            periodoins: '', //INSERT PARA EL PERIODO DEL PRESUPUESTO
            enero: '',
            febrero: '',
            marzo: '',
            abril: '',
            mayo: '',
            junio: '',
            julio: '',
            agosto: '',
            septiembre: '',
            octubre: '',
            noviembre: '',
            diciembre: '',
        };

        this.getPresupuesto = this.getPresupuesto.bind(this);
        this.guardarPresupuesto = this.guardarPresupuesto.bind(this);
        this.changeComponents = this.changeComponents.bind(this);
        this.changeYear = this.changeYear.bind(this);
        this.limpiarPantalla = this.limpiarPantalla.bind(this);
    }

    //METHODS
    changeComponents(event){
        const target = event.target;       
        const name = target.name; 
        const value = target.type === 'checkbox' ? target.checked : target.value; 
        this.setState({[name]: value});
    }    

    changeYear(event){
        const target = event.target;       
        const name = target.name; 
        const value = target.value; 

        if(value!==''){
            let anio = formatearNumeroEntero(value);
            let fechaInf = formatearNumeroEntero(this.state.anioActual) - 5;

            if(anio >= fechaInf && anio <=formatearNumeroEntero(this.state.anioActual)){
                this.setState({[name]: anio});
            }else if(name==='periodoins'){
                this.setState({[name]: anio});
            }else if(name==='periodo' && anio <= fechaInf){
                this.setState({[name]: formatearNumeroEntero(this.state.anioActual)});
                alert("Sólo puede consultar información de los últimos 5 años.");
            }
        }
    }

    getMesValue(mes){
        if(mes){
            switch (mes) {
                case 1:
                    return this.state.enero?desformatearNumeroDecimal(this.state.enero):null                   
                case 2:
                    return this.state.febrero?desformatearNumeroDecimal(this.state.febrero):null
                case 3:
                    return this.state.marzo?desformatearNumeroDecimal(this.state.marzo):null
                case 4:
                    return this.state.abril?desformatearNumeroDecimal(this.state.abril):null
                case 5:
                    return this.state.mayo?desformatearNumeroDecimal(this.state.mayo):null
                case 6:
                    return this.state.junio?desformatearNumeroDecimal(this.state.junio):null
                case 7:
                    return this.state.julio?desformatearNumeroDecimal(this.state.julio):null
                case 8:
                    return this.state.agosto?desformatearNumeroDecimal(this.state.agosto):null
                case 9:
                    return this.state.septiembre?desformatearNumeroDecimal(this.state.septiembre):null
                case 10:
                    return this.state.octubre?desformatearNumeroDecimal(this.state.octubre):null
                case 11:
                    return this.state.noviembre?desformatearNumeroDecimal(this.state.noviembre):null
                case 12:
                    return this.state.diciembre?desformatearNumeroDecimal(this.state.diciembre):null           
                default:
                    break;
            }
        }        
    }

    correctorValue(event){
        const target = event.target;       
        const name = target.name; 
        const value = target.value;

        if(value){
            if(isNaN(value)===false){
                if(value > 0){
                    this.setState({[name]: formatearNumeroDecimal(value)})
                }else{
                    this.setState({[name]: ''})
                }
            }else{
                this.setState({[name]: ''})
            }
        }else{
            this.setState({[name]: ''})
        }
    }

    cargarPresupuesto(data){
        data.forEach((MES)=>{
            if(MES.hasOwnProperty('Mes')===true){
                switch (MES.Mes) {
                    case '01':
                        this.setState({enero: MES.PMensual!==null?formatearNumeroDecimal(MES.PMensual):''});
                        break;
                    case '02':
                        this.setState({febrero: MES.PMensual!==null?formatearNumeroDecimal(MES.PMensual):''});
                        break;
                    case '03':
                        this.setState({marzo: MES.PMensual!==null?formatearNumeroDecimal(MES.PMensual):''});
                        break;
                    case '04':
                        this.setState({abril: MES.PMensual!==null?formatearNumeroDecimal(MES.PMensual):''});
                        break;
                    case '05':
                        this.setState({mayo: MES.PMensual!==null?formatearNumeroDecimal(MES.PMensual):''});
                        break;
                    case '06':
                        this.setState({junio: MES.PMensual!==null?formatearNumeroDecimal(MES.PMensual):''});   
                        break;
                    case '07':
                        this.setState({julio: MES.PMensual!==null?formatearNumeroDecimal(MES.PMensual):''});
                        break;
                    case '08':
                        this.setState({agosto: MES.PMensual!==null?formatearNumeroDecimal(MES.PMensual):''});
                        break;
                    case '09':
                        this.setState({septiembre: MES.PMensual!==null?formatearNumeroDecimal(MES.PMensual):''});
                        break;
                    case '10':
                        this.setState({octubre: MES.PMensual!==null?formatearNumeroDecimal(MES.PMensual):''});
                        break;
                    case '11':
                        this.setState({noviembre: MES.PMensual!==null?formatearNumeroDecimal(MES.PMensual):''});
                        break;
                    case '12':
                        this.setState({diciembre: MES.PMensual!==null?formatearNumeroDecimal(MES.PMensual):''});
                        break;            
                    default:
                        break;
                }
            }
        })        
    }

    //REACT CYCLE
    componentDidMount(){
        
        Promise.all([
            cargarCatalogos('TIPOPRESUPUESTO'),
            this.props.generar_LogAuditoriaIngresoForm('0508')
         ])
        .then(([ tipo ]) => {
            let fechaProceso = getFechaProcesoPorModulo('05').split('/');
            this.setState({ periodoins: fechaProceso[2], anioActual: fechaProceso[2], tipo_opt: tipo, permiso: this.props.permiso})
        })
        .catch((error )=>{
            alert(error.response?error.response.data.msg:error.message);
        });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0508');
    }
    
    //Consulta DB
    cargarObjetos(ruta){
        return new Promise((resolve, reject) => {
            global_axios.get(ruta)
            .then((response)=>{
                resolve(response.data)
            })
            .catch((err)=>{
                reject(err);
            });
        });
    }

    //ACTION BUTTONS
    getPresupuesto(){
        let errors = '';
        let proceder = true; 

        if(this.state.tipo_sel===null){
            proceder = false;
            errors+='- Seleccione un tipo de presupuesto\n'
        }

        if(this.state.periodo===''){
            proceder = false;
            errors+='- Ingrese un periodo a cargar'
        }

        if(proceder===true){
            let config_request = {
                method: 'GET',
                url: `/presupuestos?periodo=${this.state.periodo}`
            }
            this.props.cambiar_VisualizacionLoading(true);
            global_axios(config_request)
            .then((response)=>{
                this.props.cambiar_VisualizacionLoading(false);
                let data = response.data;
                this.cargarPresupuesto(data);
                this.setState({operacion: 'M'})
            }) 
            .catch((error)=>{ 
                this.props.cambiar_VisualizacionLoading(false);                          
                alert(error.response?error.response.data.msg:error.message);
            })
        }else{
            alert(errors);
        }
    }

    guardarPresupuesto(){
        let errors = '';
        let proceder = true;
        let data = {};

        if(this.state.tipoins_sel===null){
            proceder = false;
            errors+='- Seleccione un tipo de presupuesto\n'
        }

        if(this.state.periodoins==='' && this.state.operacion==='G'){
            proceder = false;
            errors+='- Ingrese un periodo.'
        }

        //Validacion de permisos
        let operacion = validarPermisoAcceso(this.state.operacion, this.state.permiso)
        if(operacion.esValido===false){
            proceder = false;
            errors = errors+' -'+operacion.msg+'\n'
        }

        if(proceder===true){
            let ArrayPresupuesto = [];
            let meses = 1
            data.Periodo = this.state.operacion==='G'?this.state.periodoins:this.state.periodo;
            data.Tipo = this.state.tipoins_sel;

            while(meses <= 12){
                let item = {}

                item.Periodo = this.state.operacion==='G'?this.state.periodoins:this.state.periodo;
                item.Mes = completar_String(meses,'0',2);
                item.PMensual = this.getMesValue(meses);
                item.TipoPresupuesto = this.state.tipoins_sel;

                ArrayPresupuesto.push(item);
                meses+=1;
            }

            data.Presupuesto = ArrayPresupuesto;

            let config_request = {
                method: this.state.operacion==='G'?'POST':'PATCH',
                url: this.state.operacion==='G'?'/presupuestos':`/presupuestos/${this.state.periodo}`,
                data
            }
            
            this.props.cambiar_VisualizacionLoading(true);
            global_axios(config_request)
            .then((response)=>{
                this.props.cambiar_VisualizacionLoading(false);
                // let data = response.data;
                alert(response.data.msg)
                this.limpiarPantalla();
            }) 
            .catch((error)=>{ 
                this.props.cambiar_VisualizacionLoading(false);                          
                alert(error.response?error.response.data.msg:error.message);
            })
        }else{
            alert(errors);
        }
    }

    limpiarPantalla(){
        let fechaProceso = getFechaProcesoPorModulo('05').split('/');
        this.setState({ periodo: '', anioActual: fechaProceso[2], periodoins: fechaProceso[2],
            enero: '', febrero: '', marzo: '', abril: '', mayo: '', junio: '', julio: '', 
            agosto: '', septiembre: '', octubre: '', noviembre: '', diciembre: '',
            tipo_sel: 'COB', operacion: 'G'})
    }
    
    render(){
        return(
            <ContenedorForm porc_ancho={45}>
                <HeaderForm>
                    <TituloForm>Ingreso de presupuesto de cobranza</TituloForm>
                </HeaderForm>
                <CuerpoForm>
                    <ContainerEdit margen_abajo='5' alto='45'>
                        <Row>  
                            <ContainerCol className='col-sm-6'>
                                <ContainerCol className='col-sm-3'>
                                    <LabelForm>Tipo:</LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-sm-9'>
                                    <ReactSelect options={ this.state.tipo_opt } value={this.state.tipo_sel} 
                                    func_onChange={(value)=>{this.setState({tipo_sel: value!==null?value.value:null})}}
                                    disabled={true}/>   
                                </ContainerCol>
                            </ContainerCol> 

                            <ContainerCol className='col-sm-6'>
                                <ContainerCol className='col-sm-3'>
                                    <LabelForm>Periodo:</LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-sm-9'>
                                    <InputSearch tipoInput='number' nombre='periodo' valor={this.state.periodo} func_CambiarValor={this.changeComponents} 
                                    func_BuscarValor={this.getPresupuesto} func_OnFocus={()=>{this.limpiarPantalla()}} maxLength='10'
                                    func_Onblur={(value)=>{this.changeYear(value)}}
                                    />                                    
                                </ContainerCol>
                            </ContainerCol>
                        </Row>
                    </ContainerEdit>
                    <Row isInvisible={this.state.operacion==='M'?true:false}>
                        <ContainerCol className='col-sm-4'>
                            <ContainerCol className='col-sm-4'>
                                <LabelForm>Periodo:</LabelForm>
                            </ContainerCol>
                            <ContainerCol className='col-sm-8'>
                                <InputText name='periodoins' value={this.state.periodoins} type="number" className='form-control input-sm'  onChange={this.changeComponents} onBlur={(value)=>{this.changeYear(value)}}/>
                            </ContainerCol>                            
                        </ContainerCol>                        
                    </Row>
                    <Row margen_arriba='7'>
                        <ContainerCol className='col-sm-4'>
                            <ContainerCol className='col-sm-4' margen_abajo='7'>
                                <LabelForm>Enero:</LabelForm>
                            </ContainerCol>
                            <ContainerCol className='col-sm-8' margen_abajo='7'>
                                <InputText  name='enero' value={this.state.enero} type="text" className='form-control input-sm'  onChange={this.changeComponents} onBlur={(value)=>{this.correctorValue(value)}} maxLength='10'/>
                            </ContainerCol>

                            <ContainerCol className='col-sm-4' margen_abajo='7'>
                                <LabelForm>Febrero:</LabelForm>
                            </ContainerCol>
                            <ContainerCol className='col-sm-8' margen_abajo='7'>
                                <InputText name='febrero' value={this.state.febrero} type="text" className='form-control input-sm'  onChange={this.changeComponents} onBlur={(value)=>{this.correctorValue(value)}} maxLength='10'/>
                            </ContainerCol>

                            <ContainerCol className='col-sm-4' margen_abajo='7'>
                                <LabelForm>Marzo:</LabelForm>
                            </ContainerCol>
                            <ContainerCol className='col-sm-8' margen_abajo='7'>
                                <InputText name='marzo' value={this.state.marzo} type="text" className='form-control input-sm'  onChange={this.changeComponents} onBlur={(value)=>{this.correctorValue(value)}} maxLength='10'/>
                            </ContainerCol>

                            <ContainerCol className='col-sm-4' margen_abajo='7'>
                                <LabelForm>Abril:</LabelForm>
                            </ContainerCol>
                            <ContainerCol className='col-sm-8' margen_abajo='7'>
                                <InputText name='abril' value={this.state.abril} type="text" className='form-control input-sm'  onChange={this.changeComponents} onBlur={(value)=>{this.correctorValue(value)}} maxLength='10'/>
                            </ContainerCol>                                                        
                        </ContainerCol>
                        
                        <ContainerCol className='col-sm-4'>
                            <ContainerCol className='col-sm-4' margen_abajo='7'>
                                <LabelForm>Mayo:</LabelForm>
                            </ContainerCol>
                            <ContainerCol className='col-sm-8' margen_abajo='7'>
                                <InputText name='mayo' value={this.state.mayo} type="text" className='form-control input-sm'  onChange={this.changeComponents} onBlur={(value)=>{this.correctorValue(value)}} maxLength='10'/>
                            </ContainerCol>

                            <ContainerCol className='col-sm-4' margen_abajo='7'>
                                <LabelForm>Junio:</LabelForm>
                            </ContainerCol>
                            <ContainerCol className='col-sm-8' margen_abajo='7'>
                                <InputText name='junio' value={this.state.junio} type="text" className='form-control input-sm'  onChange={this.changeComponents} onBlur={(value)=>{this.correctorValue(value)}} maxLength='10'/>
                            </ContainerCol>

                            <ContainerCol className='col-sm-4' margen_abajo='7'>
                                <LabelForm>Julio:</LabelForm>
                            </ContainerCol>
                            <ContainerCol className='col-sm-8' margen_abajo='7'>
                                <InputText name='julio' value={this.state.julio} type="text" className='form-control input-sm'  onChange={this.changeComponents} onBlur={(value)=>{this.correctorValue(value)}} maxLength='10'/>
                            </ContainerCol>

                            <ContainerCol className='col-sm-4' margen_abajo='7'>
                                <LabelForm>Agosto:</LabelForm>
                            </ContainerCol>
                            <ContainerCol className='col-sm-8' margen_abajo='7'>
                                <InputText name='agosto' value={this.state.agosto} type="text" className='form-control input-sm'  onChange={this.changeComponents} onBlur={(value)=>{this.correctorValue(value)}} maxLength='10'/>
                            </ContainerCol>
                        </ContainerCol>
                        
                        <ContainerCol className='col-sm-4'>                         
                            <ContainerCol className='col-sm-4' margen_abajo='7'>
                                <LabelForm>Sept.:</LabelForm>
                            </ContainerCol>
                            <ContainerCol className='col-sm-8' margen_abajo='7'>
                                <InputText name='septiembre' value={this.state.septiembre} type="text" className='form-control input-sm'  onChange={this.changeComponents} onBlur={(value)=>{this.correctorValue(value)}} maxLength='10'/>
                            </ContainerCol>

                            <ContainerCol className='col-sm-4' margen_abajo='7'>
                                <LabelForm>Oct.:</LabelForm>
                            </ContainerCol>
                            <ContainerCol className='col-sm-8' margen_abajo='7'>
                                <InputText  name='octubre' value={this.state.octubre} type="text" className='form-control input-sm'  onChange={this.changeComponents} onBlur={(value)=>{this.correctorValue(value)}} maxLength='10'/>
                            </ContainerCol>

                            <ContainerCol className='col-sm-4' margen_abajo='7'>
                                <LabelForm>Nov.:</LabelForm>
                            </ContainerCol>
                            <ContainerCol className='col-sm-8' margen_abajo='7'>
                                <InputText  name='noviembre' value={this.state.noviembre} type="text" className='form-control input-sm'  onChange={this.changeComponents} onBlur={(value)=>{this.correctorValue(value)}} maxLength='10'/>
                            </ContainerCol>

                            <ContainerCol className='col-sm-4' margen_abajo='7'>
                                <LabelForm>Dic.:</LabelForm>
                            </ContainerCol>
                            <ContainerCol className='col-sm-8' margen_abajo='7'>
                                <InputText name='diciembre' value={this.state.diciembre} type="text" className='form-control input-sm'  onChange={this.changeComponents} onBlur={(value)=>{this.correctorValue(value)}} maxLength='10'/>
                            </ContainerCol>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-12'>
                            <ContainerCol className='btn-group pull-right' margen_arriba='7'>
                                <button type='button' className='btn btn-primary btn-sm' disabled={false} onClick={this.guardarPresupuesto}><i className="fa fa-floppy-o fa-lg" aria-hidden="true"/> Guardar</button>   
                                <button type="button" className='btn btn-sm'  onClick={this.limpiarPantalla}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                            </ContainerCol>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const mapStateToProps = ((state) => {
return {puntoFacturacionSel: state.ventas.ptoFacturacionSel, 
        permiso: state.sesion.valoresSesionForm.Permiso,
        usuario: state.sesion.valoresSesionForm.Usuario,
        IdRegAudit: state.sesion.valoresSesionForm.IdRegAudit,
        departamento : state.sesion.valoresSesionForm.Departamento}
});
    
const mapDispatchToProps = ((dispatch) => {  
return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm,
                            cambiar_VisualizacionLoading }, dispatch)
});

export default connect (mapStateToProps, mapDispatchToProps)(FormCaja08);